export default "__VITE_ASSET__WXx$C6AK__"